/* 
▗▖  ▗▖▗▖ ▗▖▗▄▄▄▖▗▄▄▄▖▗▖  ▗▖ ▗▄▖     ▗▄▄▄▖▗▖ ▗▖▗▄▄▄▖▗▖  ▗▖▗▄▄▄▖    ▗▄▄▖ ▗▖ ▗▖▗▄▄▄▖▗▖   ▗▄▄▄ ▗▄▄▄▖▗▄▄▖ 
▐▛▚▖▐▌▐▌ ▐▌  █    █  ▐▛▚▞▜▌▐▌ ▐▌      █  ▐▌ ▐▌▐▌   ▐▛▚▞▜▌▐▌       ▐▌ ▐▌▐▌ ▐▌  █  ▐▌   ▐▌  █▐▌   ▐▌ ▐▌
▐▌ ▝▜▌▐▌ ▐▌  █    █  ▐▌  ▐▌▐▛▀▜▌      █  ▐▛▀▜▌▐▛▀▀▘▐▌  ▐▌▐▛▀▀▘    ▐▛▀▚▖▐▌ ▐▌  █  ▐▌   ▐▌  █▐▛▀▀▘▐▛▀▚▖
▐▌  ▐▌▝▚▄▞▘  █  ▗▄█▄▖▐▌  ▐▌▐▌ ▐▌      █  ▐▌ ▐▌▐▙▄▄▖▐▌  ▐▌▐▙▄▄▖    ▐▙▄▞▘▝▚▄▞▘▗▄█▄▖▐▙▄▄▖▐▙▄▄▀▐▙▄▄▖▐▌ ▐▌
  
* NUTIMA THEME BUILDER
* Shopify Theme Compiler & Generator powered by nutima
* 
* Copyright (c) 2025 nutima
* All rights reserved.
* 
* ⚠️  WARNING: This file is auto-generated by Nutima Theme Builder
* ⚠️  DO NOT EDIT this file manually - your changes will be overwritten
* ⚠️  To make changes, edit the source files and rebuild the theme
* 
* Version: 1.0.0
* Build: Production
* 
* For support: support@nutima.agency
* Website: https://nutima.agency
 */
document.querySelectorAll(".main-page__menu-header").forEach((e=>{e.addEventListener("click",(()=>{e.parentNode.classList.toggle("main-page__menu--active")}))}));